module.exports = __webpack_public_path__ + "assets/fonts/MiloOffc-Medium.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/milo-medium/MiloOffc-Medium.woff
// module id = 520
// module chunks = 0